import { COMPONENTS, SCRIPTS } from "//shop.pigeon.co.jp/cdn/shop/t/149/assets/config.js?v=94634950909479938561792978931"
import * as Vue from 'vue'
import { loadModule } from 'sfc-loader'
import { State } from "//shop.pigeon.co.jp/cdn/shop/t/149/assets/store.js?v=175662040855137230871792978933"
// https://github.com/FranckFreiburger/vue3-sfc-loader/blob/main/docs/examples.md

const { createApp } = Vue

/**
 * ES5モジュールのロード
 * @param {string} src 
 * @returns 
 */
function scriptLoader(src) {
    return new Promise((resolve, reject) => {
        let scriptElm = document.createElement('script')
        scriptElm.src = src
        scriptElm.addEventListener('load', () => {
            resolve(src)
        })
        scriptElm.addEventListener('error', (ev) => {
            console.error(ev)
            reject({ src, ev })
        })
        document.head.appendChild(scriptElm)
    })
}

/**
 * importmapリストの取得（JSの連想配列にパース）
 * @returns {string[]}
 */
function getImportmap() {
    let importmap = {}
    const importmapElm = document.querySelector('script[type="importmap"]')
    if (importmapElm) {
        importmap = JSON.parse(importmapElm.textContent).imports
    }
    return importmap
}

/**
 * ESM（ES モジュール）のロード
 * @param {string[]} importmap 
 * @returns 
 */
async function moduleCacheLoader(importmap) {
    let modules = {}
    for (const [modueName, modueUrl] of Object.entries(importmap)) {
        modules[modueName] = await import(modueUrl)
    }
    modules.vue = Vue
    await State.init()
    modules.store = State // 状態管理用インスタンスを設定し、Vueコンポーネント上から操作できるようにする
    return modules
}

async function getBlobURL(url){
    const blob = await (await fetch(url)).blob()
    const blobUrl = URL.createObjectURL(blob)
    console.log(blobUrl)
    return blobUrl
}


/**
 * メイン関数（エントリーポイント）
 */
async function main() {
    /**
     * HTMLファイルのImportmapを取得
     */
    const importmap = getImportmap()
    /**
     * ES5 Moduleの読み込み
     */
    for (const script of SCRIPTS) {
        await scriptLoader(script)
    }
    /**
     * Vueファイルの読み込み時のオプション
     * ・import文内のURLの処理方法
     * ・スタイル（CSS）の処理方法
     */
    const options = {
        moduleCache: await moduleCacheLoader(importmap),
        /**
         * VueコンポーネントのJS上でインポートされるインポート元の処理方法
         * @param {string} url 
         * @returns 
         */
        async getFile(url) {
            let importUrl = Object.keys(importmap).includes(url) ? importmap[url] : url
          const res = await fetch(importUrl)
            if (!res.ok)
                throw Object.assign(new Error(res.statusText + ' ' + importUrl), { res })

            return {
                getContentData: asBinary => asBinary ? res.arrayBuffer() : res.text(),
            }
        },
        /**
         *  VueコンポーネントのJS上のCSS（スタイル）の処理方法
         * @param {string} textContent 
         */
        addStyle(textContent) {
            const style = Object.assign(document.createElement('style'), { textContent })
            const ref = document.head.getElementsByTagName('style')[0] || null
            document.head.insertBefore(style, ref)
        },
      /**
       * パラメータ付きURLへの対応
       * @param {string} pathCx 
       * @param {any} options 
       * @returns 
       */
      getResource(pathCx, options){
          const { pathResolve, getFile, log } = options;
          const path = pathResolve(pathCx)
          const pathStr = path.toString()
          const ext = '.' + pathStr.split('?')[0].split('.').pop() // 拡張子の調整
          return {
              id: pathStr,
              path: path,
              getContent: async () => {

                  const res = await getFile(path);

                  if ( typeof res === 'string' || res instanceof ArrayBuffer ) {

                      return {
                          type: ext,
                          getContentData: async (asBinary) => {

                              if ( res instanceof ArrayBuffer !== asBinary )
                                  log?.('warn', `unexpected data type. ${ asBinary ? 'binary' : 'string' } is expected for "${ path }"`);
                              
                              return res;
                          },
                      }
                  }

                  return {
                      type: res.type ?? ext,
                      getContentData: res.getContentData,
                  }
              }
          }
      },
    }
    /**
     * Appコンポーネント（*.vue）の読み込み
     */
    const entry = await loadModule("//shop.pigeon.co.jp/cdn/shop/t/149/assets/app.vue?v=19441764757259105691719968010", options)
    /**
     * Vueのインスタンス生成
     */
    const app = createApp(entry)
    /**
     * その他必要なコンポーネント（*.vue）の読み込み
     */
    for (const [componentName, file] of Object.entries(COMPONENTS)) {
        app.component(componentName, await loadModule(`${file}`, options))
    }
    /**
     * Appコンポーネントのマウント
     */
    app.mount('#app')
}

/**
 * メイン関数の実行
 */
main()
